"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var RefreshSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.8666023,8 C12.4107997,6.2500155 10.9795246,5 9,5 C7.72135778,5 6.70939797,5.65855406 5.67161801,7 L8,7 L8,8 L4,8 L4,4 L5,4 L5,6.23571107 C6.17645568,4.76385276 7.39808117,4 9,4 C11.5162555,4 13.4036181,5.5 13.89,8 C13.63,8 13.2888674,8 12.8666023,8 Z M5.02709586,10 C5.48289847,11.7499845 6.91417353,13 8.89369815,13 C10.1723404,13 11.1843002,12.3414459 12.2220801,11 L9.89369815,11 L9.89369815,10 L13.8936981,10 L13.8936981,14 L12.8936981,14 L12.8936981,11.7642889 C11.7172425,13.2361472 10.495617,14 8.89369815,14 C6.37744268,14 4.5,12.5 4,10 C4.33333333,10 4.67569862,10 5.02709586,10 Z" })));
};
RefreshSmall.displayName = 'RefreshSmall';
exports.default = RefreshSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=RefreshSmall.js.map